
/**
 * 트윗 태그 정보
 */
export type GetTweetById200Tags = {
  hashtags?: string[];
};
